import { Component, OnInit, Input, EventEmitter, HostListener, Output } from '@angular/core';

export interface IFileInputValueChangeEvent {
    localFile: ILocalFile;
}

export interface ILocalFile {
    filename: string;
    resultData: any;
}

export type InputMode = 'input-box' | 'dragdrop-zone';
export type DataType = 'image' | 'text';

@Component({
    selector: 'local-file-input',
    templateUrl: './local-file-input.component.html',
    styleUrls: ['./local-file-input.component.scss']
})
export class LocalFileInputComponent {
    @Input()
    public localFile: ILocalFile;

    @Input()
    public placeholderText: string;

    @Input()
    public mode: InputMode = 'input-box';

    @Input()
    public dataType: DataType;

    @Input()
    public mimeType: string = '*';

    @Output()
    public fileSelected = new EventEmitter<IFileInputValueChangeEvent>();

    private isDraggingOver: boolean;

    constructor() {}

    public chooseFile(event: any) {
        const localFile = event.target.files[0];
        this.readFile(localFile);
    }

    private readFile(localFile: any) {
        const reader = new FileReader();
        reader.onload = (loadEvent) => {
            const selectedLocalFile: ILocalFile = {
                filename: localFile.name,
                resultData: reader.result
            };

            this.localFile = selectedLocalFile;
            this.fileSelected.emit({ localFile: selectedLocalFile });
        };

        if (this.dataType === 'text')
            reader.readAsText(localFile);
        else if (this.dataType === 'image')
            reader.readAsDataURL(localFile);
    }
}



// WEBPACK FOOTER //
// ./src/viega-common/components/local-file-input/local-file-input.component.ts